module.exports = __webpack_public_path__ + "static/media/teoLogoBleu.21f2e0e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teoLogoBleu.png
// module id = 282
// module chunks = 0